import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltip'
})
export class TooltipPipe implements PipeTransform {

  transform(value: string | null, minLength: number = 2): string {
    if (!value) {
      return '';
    }
    return value.length > minLength ? value : '';
  }

}
